// extracted by mini-css-extract-plugin
export default {"emptyTable":"styles_emptyTable__9mHhI","text":"styles_text__QcsXs","assignButton":"styles_assignButton__LKEqi"};